import { ListItem, Tooltip } from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import Svg from "../../ui library/components/svgs/standard/svg";

export default function SideBarMenuItem({Menu, index, isActivePath, open, setOpen, activeRoute}) {
    const location = useLocation();

  return (
    <ListItem
      key={Menu.title}
      className={`flex rounded-md p-2 cursor-pointer hover:bg-light-white text-black text-sm items-center gap-x-4`}
    >
      <Tooltip title={Menu.title} placement="right">
        <Link
          name={Menu.title}
          className="flex items-center w-full gap-6 rounded-md hover:text-white"
          style={isActivePath(Menu.url) ? { pointerEvents: "none" } : null}
          to={
            Menu.handlerFn ? `${location.pathname}${location.search}` : Menu.url
          }
          onClick={() => {
            Menu.handlerFn?.();
            setOpen(false);
          }}
        >
          <span
            style={{
              backgroundColor:
                Menu.key === activeRoute ? "#ECF2FF" : "transparent",
              padding: "6px 9px",
              borderRadius: "5px",
              display: "flex",
              position: "relative",
              overflow: "visible",
            }}
          >
            {Menu.key === activeRoute && (
              <span
                style={{
                  width: "5px",
                  backgroundColor: "#247DF8",
                  borderRadius: "15px",
                  position: "absolute",
                  height: "36px",
                  top: "0",
                  left: "-8px",
                }}
              ></span>
            )}
            <Svg
              name={Menu.icon}
              color={Menu.key === activeRoute ? "#247DF8" : undefined}
            />
          </span>
          <span
            className={`${
              !open && "hidden"
            } pl-2 origin-left duration-200 text-black hover:text-blue-600`}
          >
            {Menu.title}
          </span>
        </Link>
      </Tooltip>
    </ListItem>
  );
}
